/* ================================================== */
/* MENU
/* ================================================== */

var $menu = $('#menu'),
	$trigger = $('#menu-trigger'),
	$links = $('#menu-links'),
	$focus;

function openMenu() {
	// Accessibility
	$focus = $(':focus');
	$('a:not([data-tabindex])', $menu).attr('tabindex', '0');
	$links.slideDown();
	$trigger.attr('aria-expanded', 'true');

	// Update state
	$menu.attr('data-expanded', 'true');
	if ($trigger.length) toggleHamburger($trigger.find('.hamburger'));
}

function closeMenu() {
	// Accessibility
	$('a', $menu).attr('tabindex', '-1');
	$links.slideUp();
	$trigger.attr('aria-expanded', 'false');
	$focus.focus();

	// Update state
	$menu.attr('data-expanded', 'false');
	if ($trigger.length) toggleHamburger($trigger.find('.hamburger'));
}

$(document).ready(function() {
	if ($menu.length) {
		// Inits
		prevScroll = $(window).scrollTop();

		// Toggle on click
		$trigger.click(function() {
			($menu.attr('data-expanded') == 'false') ? openMenu() : closeMenu();
		});

		// Toggle on “Enter”
		$(document).on('keyup', function(event) {
			if (event.keyCode === 13 && $trigger.is(':focus')) {
				($menu.attr('data-expanded') == 'false') ? openMenu() : closeMenu();
			}
		});

		// Close on “Esc”
		$(document).on('keyup', function(event) {
			if (event.keyCode === 27 && $menu.length && $menu.attr('data-expanded') == 'true') closeMenu();
		});

		// Scroll to menu
		if ($('#body').is('.type-homepage') && $('#header').length) {
			$trigger.click(function() {
				if ($(window).scrollTop() <= $('#header').outerHeight()) {
					scrollTo('#menu');
				}
			});
		}
	}
});